import {
  palette,
  shape,
  breakpoints as sharedBreakpoints,
  overrides as sharedOverrides,
  props as sharedProps,
  spacing as sharedSpacing,
  typography as sharedTypography,
} from '@fluentsms/agentnet-web-components';
import { createMuiTheme } from '@material-ui/core';
import overrides from './overrides';
import props from './props';

// TODO: Remove all Fluent's original theming in favor of lib-agentnet's shared theming where applicable
// Taking the palette will cause us to check every page when the time comes
const combinedProps = {
  ...props,
  MuiButton: {
    ...sharedProps.MuiButton,
  },
  MultiSelect: {
    ...sharedProps.MuiSelect?.MenuProps,
    variant: sharedProps.MuiSelect?.variant,
  },
  MuiTextField: {
    ...sharedProps.MuiTextField,
  },
};
const combinedOverrides = {
  ...overrides,
  ...sharedOverrides.MuiCssBaseline,
  MuiButton: {
    ...sharedOverrides.MuiButton,
  },
  MuiCardActionArea: {
    ...sharedOverrides.MuiCardActionArea,
  },
  MuiIconButton: {
    ...sharedOverrides.MuiIconButton,
  },
  MuiLink: {
    ...sharedOverrides.MuiLink,
  },
  MuiList: {
    ...sharedOverrides.MuiList,
  },
  MuiListItem: {
    ...sharedOverrides.MuiListItem,
  },
  MuiListItemAvatar: {
    ...sharedOverrides.MuiListItemAvatar,
  },
  MuiListItemIcon: {
    ...sharedOverrides.MuiListItemIcon,
  },
  MuiListItemText: {
    ...sharedOverrides.MuiListItemText,
  },
  MuiListSubheader: {
    ...sharedOverrides.MuiListSubheader,
  },
  MuiSvgIcon: {
    ...sharedOverrides.MuiSvgIcon,
  },
  MuiTable: {
    ...sharedOverrides.MuiTable,
  },
  MuiTableRow: {
    ...sharedOverrides.MuiTableRow,
  },
  MuiTableCell: {
    ...sharedOverrides.MuiTableCell,
  },
  MuiTypography: {
    ...sharedOverrides.MuiTypography,
  },
};
export const theme = createMuiTheme({
  breakpoints: sharedBreakpoints,
  palette,
  props: combinedProps,
  overrides: combinedOverrides,
  spacing: sharedSpacing,
  typography: sharedTypography,
  shape,
});
